import React from 'react';

import { schemas } from '@recurrency/core-api-schema';
import { Switch } from 'antd';
import { theme } from 'theme';

import { FlexSpace } from 'components/FlexSpace';

import { useCoreApi } from 'hooks/useApi';

import { formatPercent, formatUSDAbbreviated } from 'utils/formatting';

import { InventoryBarChart } from '../InventoryBarChart';
import { useInventoryReportFilters } from '../useInventoryReportFilters';
import { calculatePercentageBuckets } from '../utils';
import { MetricsCard } from './MetricsCard';

export function InventoryAgingChart() {
  const reportFilters = useInventoryReportFilters();
  const [showInventoryAgingInPercent, setShowInventoryAgingInPercent] = React.useState(false);

  const {
    data: agingData,
    isLoading,
    isReloading,
  } = useCoreApi(schemas.inventory.getInventoryAgingReport, { queryParams: { filters: reportFilters } });

  const bucketValues = calculatePercentageBuckets(
    agingData?.items.map((item) => ({ date: item.date, value: item.inventoryAgingAmount })) || [],
  );

  return (
    <MetricsCard
      title="Inventory Age (Months)"
      description="The age of inventory using a FIFO method working backwards from the current inventory count."
      loading={isLoading || isReloading}
      headerActions={
        <FlexSpace>
          <b>Display in %</b>
          <Switch checked={showInventoryAgingInPercent} onClick={setShowInventoryAgingInPercent} />
        </FlexSpace>
      }
    >
      <InventoryBarChart
        data={bucketValues.map((bucket) => ({
          date: bucket.name,
          inventoryAgingAmount: showInventoryAgingInPercent ? bucket.percentage : bucket.value,
        }))}
        valueFormatter={(value) =>
          showInventoryAgingInPercent ? formatPercent(value / 100) : formatUSDAbbreviated(value)
        }
        xAxisFormatter={(value) => `${value}`}
        tooltipTitle={(payload) => `${payload.date}`}
        bars={[
          {
            key: 'inventoryAgingAmount',
            color: theme.colors.chart.lightPurple,
            secondaryColor: theme.colors.chartLight.sunsetPurple,
            title: 'Inventory Aging',
          },
        ]}
        percentageDomain={showInventoryAgingInPercent}
        height={300}
      />
    </MetricsCard>
  );
}
